type Props = {
  title?: string
}

export function BimssHeader({ title = 'MY BARANGAY' }: Props) {
  return (
    <div className="flex flex-col items-center pt-4 pb-2 border-b">
      <div className="mb-3">
        <BimssOOLogo />
      </div>
      <h1 className="text-base font-medium tracking-wider text-foreground">
        {title}
      </h1>
    </div>
  )
}

function BimssOOLogo() {
  return (
    <svg width="40" height="22" viewBox="0 0 40 22">
      <circle cx="11" cy="11" r="10" fill="#dc2626" stroke="white" strokeWidth="1" />
      <circle cx="29" cy="11" r="10" fill="#dc2626" stroke="white" strokeWidth="1" />
      <circle cx="11" cy="11" r="3" fill="white" />
      <circle cx="29" cy="11" r="3" fill="white" />
    </svg>
  )
}
